// Function to store data in local storage
export const saveLocalStorageData = (key, data) => {
  try {
    localStorage.setItem(key, data);
  } catch (error) {
    console.error(`Error storing data: ${error}`);
  }
}

// Function to retrieve data from local storage
export const getLocalStorageData = (key) => {
  try {
    const data = localStorage.getItem(key);
    if (data === null) {
      return null;
    }
    return JSON.parse(data);
  } catch (error) {
    console.error(`Error retrieving data: ${error}`);
    return null;
  }
}

// Function to remove data from local storage
export const clearLocalStorageData = (key) => {
  try {
    if (key) {
      localStorage.removeItem(key);
      console.log(`Data with key ${key} cleared from local storage`);
    }
  } catch (error) {
    console.error(`Error clearing data: ${error}`);
  }
}